import { AxiosResponse } from "axios";
import { showFeedback } from "../general/feedback";
import i18next from "i18next";

export enum ActionType {
  create,
  update,
  delete,
  renew,
}

const trfb = (msgKey: string, params?: any) =>
  params
    ? i18next.t(`${msgKey}`, i18next.t("errors:error.generic"), {
        ns: "feedback",
        ...params,
      })
    : i18next.t(`${msgKey}`, i18next.t("errors:error.generic"), {
        ns: "feedback",
      });

const resParam = (resourceKey: string) => {
  return { resource: i18next.t(resourceKey, { ns: "resource" }) };
};

const feedbackMessages = {
  [ActionType.renew]: {
    success: (resourceKey: string) =>
      trfb("feedback.renew.success", resParam(resourceKey)),
    error: (resourceKey: string) =>
      trfb("feedback.renew.error", resParam(resourceKey)),
  },
  [ActionType.create]: {
    success: (resourceKey: string) =>
      trfb("feedback.create.success", resParam(resourceKey)),
    error: (resourceKey: string) =>
      trfb("feedback.create.error", resParam(resourceKey)),
  },
  [ActionType.update]: {
    success: () => trfb("feedback.update.success"),
    error: () => trfb("feedback.update.error"),
  },
  [ActionType.delete]: {
    success: (resourceKey: string) =>
      trfb("feedback.delete.success", resParam(resourceKey)),
    error: (resourceKey: string) =>
      trfb("feedback.delete.error", resParam(resourceKey)),
  },
};

export const handleActionWithFeedback = async <T>(
  action: () => Promise<AxiosResponse<T>>,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  thunkApi: any,
  actionType: keyof typeof feedbackMessages,
  resourceName: string
): Promise<T> => {
  try {
    const { data } = await action();
    thunkApi.dispatch(
      showFeedback({
        error: false,
        message: feedbackMessages[actionType].success(resourceName) as string,
      })
    );
    return data;
  } catch (err: any) {
    const errorDetails = err.response.data.errorKey
      ? trfb(err.response.data.errorKey, err.response.data.errorKeyParams)
      : i18next.t(
          "errors:" + err.response.data.message,
          err.response.data.message
        );

    thunkApi.dispatch(
      showFeedback({
        error: true,
        message: `${feedbackMessages[actionType].error(
          resourceName
        )}: ${errorDetails}`,
      })
    );
    return thunkApi.rejectWithValue(err.response.data);
  }
};
